import { defineStore } from "pinia";
import { customBrandingUpdate } from '@/services/CustomBranding';
import { getButtonFontColor } from "@/helpers/ValidateColorHelper";
const whiteRGB = { r: 255, g: 255, b: 255 };
import useAuthStore from "@/store/AuthPinia";
export const useCustomBrandingStore = defineStore('customBranding', {
    state: () => ({
        defaultPrimary: '#07151E',
        defaultSecondary: '#1B4965',
        branding_workspace_name: null,
        branding_primary_color: null,
        branding_secondary_color: null,
        branding_logo: null,
        branding_favicon: null,
        authStore: useAuthStore(),
    }),
     
           
    getters: {
        brandingLogo(state) {
            return state.branding_logo
        },
        brandingFavicon(state) {
            return state.branding_favicon
        },
        brandingPrimaryColor(state) {
            return state.branding_primary_color
        },
        brandingSecondaryColor(state) {
            return state.branding_secondary_color
        },
    },
    actions: {
        setCustomBrandingFromProfileData(user) {
            this.branding_workspace_name = user.branding_workspace_name;
            this.branding_primary_color = user.branding_primary_color;
            this.branding_secondary_color = user.branding_secondary_color;
            this.branding_logo = user.branding_logo;
            this.branding_favicon = user.branding_favicon;
            this.updateBrandingView();
        },
        
        async updateBrandingWorkspaceName(newWorkspaceName) {
            let response = await customBrandingUpdate({branding_workspace_name: newWorkspaceName})
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                document.title = this.branding_workspace_name;
            }
            return response;
        },
        async updateBrandingLogo(logo) {
            let response = await customBrandingUpdate({branding_logo: logo});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
            }
            return response;
        },
        async updateBrandingFavicon(faveicon) {
            let response = await customBrandingUpdate({branding_favicon: faveicon});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                this.setBrandingFaviconView();
            }
            return response;
        },
   
        async updateBrandingColors(primaryColor, secondaryColor) {
            let response = await customBrandingUpdate({branding_primary_color: primaryColor, branding_secondary_color: secondaryColor, branding_primary_color_font_inverse: getButtonFontColor('--primary-color-font-inverse', primaryColor), branding_secondary_color_font_inverse: getButtonFontColor('--secondary-color-font-inverse', secondaryColor)});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                this.setBrandingColorsView();
            }
            return response;
        },
        // Global update branding function on first load
        updateBrandingView(){
             if (this.branding_workspace_name ) {
                document.title = this.branding_workspace_name;
            }
            
            if (this.branding_favicon) {
                this.setBrandingFaviconView();
            }
            this.setBrandingColorsView();
        },
        setBrandingFaviconView() {
            let faviconElement = document.querySelector('link[rel="icon"]');
            faviconElement.href = this.branding_favicon;
        },
        setBrandingColorsView() {
            document.documentElement.style.setProperty('--primary-color', this.branding_primary_color);
            document.documentElement.style.setProperty('--secondary-color', this.branding_secondary_color);
            document.documentElement.style.setProperty('--user-nav-icon-bg-color', this.branding_secondary_color);
            // Check if primary is too close to white then change font color
            getButtonFontColor('--primary-color-font-inverse', this.branding_primary_color);
            // Check if secondary is too close to white then change font color
            getButtonFontColor('--secondary-color-font-inverse', this.branding_secondary_color);
           // Check if secondary is too close to white for "no background" buttons
            getButtonFontColor('--secondary-btn-no-bg-color', this.branding_secondary_color, this.branding_primary_color, this.branding_secondary_color);
        },
        async resetBrandingLogo() {
            let response = await customBrandingUpdate({branding_logo: ''});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
            }
            return response;
        },
        async resetBrandingFavicon() {
            let response = await customBrandingUpdate({branding_favicon: ''});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                this.setBrandingFaviconView();
            }
            return response;
        },
        async resetBrandingImages() {
            let response = await customBrandingUpdate({branding_favicon: '', branding_logo: ''});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                this.setBrandingFaviconView();
            }
            return response;
        },
        async resetBrandingColors() {
            let response = await customBrandingUpdate({branding_primary_color: '', branding_secondary_color: '', branding_primary_color_font_inverse: '', branding_secondary_color_font_inverse: ''});
            if (response.status) {
                this.setValueFromArrayKey(response.response.settings);
                this.setBrandingColorsView();
            }
            return response;
        },
        
        setValueFromArrayKey(arrayOfSettings) {
            arrayOfSettings.forEach(setting => {               
                this[setting.key] = setting.value;
            })
        }
    }
});
export default useCustomBrandingStore;
